import { useState } from 'react';

export default function PipelineInspection() {
  const [selectedType, setSelectedType] = useState('全部');

  const pipelineRecords = [
    { id: 'PL001', name: '1号输油管道', type: '输油管道', length: '2.5km', lastInspection: '2024-01-14 08:30', status: '正常', issues: 0, nextInspection: '2024-01-21' },
    { id: 'PL002', name: '2号输油管道', type: '输油管道', length: '3.2km', lastInspection: '2024-01-14 10:15', status: '轻微隐患', issues: 1, nextInspection: '2024-01-21' },
    { id: 'BR001', name: '东港高架桥', type: '高架桥', length: '1.8km', lastInspection: '2024-01-14 14:20', status: '正常', issues: 0, nextInspection: '2024-01-21' },
    { id: 'BR002', name: '西港高架桥', type: '高架桥', length: '2.1km', lastInspection: '2024-01-14 15:45', status: '轻微隐患', issues: 2, nextInspection: '2024-01-21' },
    { id: 'PL003', name: '3号输油管道', type: '输油管道', length: '4.0km', lastInspection: '2024-01-15 09:00', status: '正常', issues: 0, nextInspection: '2024-01-22' },
  ];

  const issueList = [
    { id: 'IS001', facility: '2号输油管道', location: '2.3km处', type: '管道腐蚀', severity: '中', discoveryTime: '2024-01-14 10:20', status: '处理中' },
    { id: 'IS002', facility: '西港高架桥', location: '桥墩B3', type: '混凝土开裂', severity: '中', discoveryTime: '2024-01-14 15:50', status: '待处理' },
    { id: 'IS003', facility: '西港高架桥', location: '伸缩缝C区', type: '伸缩缝损坏', severity: '低', discoveryTime: '2024-01-14 16:00', status: '待处理' },
  ];

  const filteredRecords = selectedType === '全部' 
    ? pipelineRecords 
    : pipelineRecords.filter(r => r.type === selectedType);

  return (
    <div className="space-y-6">
      {/* 统计卡片 */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">巡检总里程</span>
            <i className="ri-route-line text-2xl text-teal-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">13.6km</div>
          <div className="text-xs text-teal-400">本周累计</div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">发现问题</span>
            <i className="ri-alert-line text-2xl text-orange-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">3</div>
          <div className="text-xs text-orange-400">1个处理中</div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">巡检完成率</span>
            <i className="ri-checkbox-circle-line text-2xl text-green-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">100%</div>
          <div className="text-xs text-green-400">按计划执行</div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">平均巡检时长</span>
            <i className="ri-time-line text-2xl text-blue-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">45min</div>
          <div className="text-xs text-blue-400">每公里</div>
        </div>
      </div>

      {/* 巡检画面 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <i className="ri-camera-line text-teal-400"></i>
          实时巡检画面
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="relative rounded-lg overflow-hidden h-48">
            <img 
              src="https://public.readdy.ai/ai/img_res/17d6d6f30728d942812ae9c54401f099.jpg"
              alt="输油管道巡检"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
              <div className="text-white text-sm font-medium">2号输油管道检查</div>
              <div className="text-orange-400 text-xs">发现腐蚀 - 2024-01-14 10:20</div>
            </div>
          </div>
          <div className="relative rounded-lg overflow-hidden h-48">
            <img 
              src="https://readdy.ai/api/search-image?query=elevated%20highway%20bridge%20inspection%20from%20drone%20perspective%20showing%20concrete%20pillars%20and%20bridge%20deck%20structure%2C%20professional%20infrastructure%20photography%2C%20bright%20daylight%2C%20technical%20documentation%20angle%2C%20clear%20structural%20details&width=600&height=400&seq=pipeline-inspect-002&orientation=landscape"
              alt="高架桥巡检"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
              <div className="text-white text-sm font-medium">西港高架桥检查</div>
              <div className="text-orange-400 text-xs">发现裂纹 - 2024-01-14 15:50</div>
            </div>
          </div>
          <div className="relative rounded-lg overflow-hidden h-48">
            <img 
              src="https://readdy.ai/api/search-image?query=bridge%20expansion%20joint%20close-up%20inspection%20showing%20concrete%20crack%20and%20structural%20damage%20detail%2C%20technical%20inspection%20photography%2C%20clear%20focus%20on%20damaged%20area%2C%20professional%20documentation%20style%2C%20daylight%20conditions&width=600&height=400&seq=pipeline-inspect-003&orientation=landscape"
              alt="伸缩缝检查"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
              <div className="text-white text-sm font-medium">伸缩缝损坏检查</div>
              <div className="text-yellow-400 text-xs">轻微损坏 - 2024-01-14 16:00</div>
            </div>
          </div>
        </div>
      </div>

      {/* 巡检记录 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-white flex items-center gap-2">
            <i className="ri-file-list-line text-teal-400"></i>
            管道桥梁巡检记录
          </h3>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setSelectedType('全部')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                selectedType === '全部' 
                  ? 'bg-teal-500 text-white' 
                  : 'bg-gray-700/50 text-gray-300 hover:bg-gray-700'
              }`}
            >
              全部
            </button>
            <button
              onClick={() => setSelectedType('输油管道')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                selectedType === '输油管道' 
                  ? 'bg-teal-500 text-white' 
                  : 'bg-gray-700/50 text-gray-300 hover:bg-gray-700'
              }`}
            >
              输油管道
            </button>
            <button
              onClick={() => setSelectedType('高架桥')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                selectedType === '高架桥' 
                  ? 'bg-teal-500 text-white' 
                  : 'bg-gray-700/50 text-gray-300 hover:bg-gray-700'
              }`}
            >
              高架桥
            </button>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-700">
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">设施编号</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">设施名称</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">类型</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">长度</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">最近巡检</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">状态</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">问题数</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">下次巡检</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">操作</th>
              </tr>
            </thead>
            <tbody>
              {filteredRecords.map((record) => (
                <tr key={record.id} className="border-b border-gray-700/50 hover:bg-gray-700/30 transition-colors">
                  <td className="py-3 px-4 text-sm text-white">{record.id}</td>
                  <td className="py-3 px-4 text-sm text-white">{record.name}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{record.type}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{record.length}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{record.lastInspection}</td>
                  <td className="py-3 px-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      record.status === '正常' ? 'bg-green-500/20 text-green-400' :
                      'bg-orange-500/20 text-orange-400'
                    }`}>
                      {record.status}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm">
                    <span className={record.issues > 0 ? 'text-red-400 font-medium' : 'text-gray-400'}>
                      {record.issues}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-300">{record.nextInspection}</td>
                  <td className="py-3 px-4">
                    <button className="text-teal-400 hover:text-teal-300 text-sm cursor-pointer whitespace-nowrap">
                      查看详情
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 问题列表 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <i className="ri-error-warning-line text-orange-400"></i>
          问题详细列表
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-700">
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">问题编号</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">所属设施</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">位置</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">问题类型</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">严重程度</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">发现时间</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">处理状态</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">操作</th>
              </tr>
            </thead>
            <tbody>
              {issueList.map((issue) => (
                <tr key={issue.id} className="border-b border-gray-700/50 hover:bg-gray-700/30 transition-colors">
                  <td className="py-3 px-4 text-sm text-white">{issue.id}</td>
                  <td className="py-3 px-4 text-sm text-white">{issue.facility}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{issue.location}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{issue.type}</td>
                  <td className="py-3 px-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      issue.severity === '低' ? 'bg-blue-500/20 text-blue-400' :
                      'bg-orange-500/20 text-orange-400'
                    }`}>
                      {issue.severity}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-300">{issue.discoveryTime}</td>
                  <td className="py-3 px-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      issue.status === '待处理' ? 'bg-yellow-500/20 text-yellow-400' :
                      'bg-blue-500/20 text-blue-400'
                    }`}>
                      {issue.status}
                    </span>
                  </td>
                  <td className="py-3 px-4">
                    <button className="text-teal-400 hover:text-teal-300 text-sm cursor-pointer whitespace-nowrap">
                      处理
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}